const openCellInNewTab = (url,e) => {
    if(e.target.localName==='whippy-ph'||e.target.localName==='p'){
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
}

export default openCellInNewTab;